/* Scroll-triggered motion. Plays once per element. Items that appear together (a row of photos, the words of a heading) are staggered in page order.
   REVEAL = elements that fade up (data-hm-reveal plus the AUTO list). KEEP THE AUTO LIST IN SYNC WITH hm-motion.css.
   ANIM = elements that just get an is-in class, which the CSS turns into a push-in or pop. */
(function(){
  if(window.__hmMotion) return;
  var STEP=110, MAXK=7;
  var AUTO='.hm-m__inner > .hm-m__h,.hm-m__inner > .hm-m__sub,.hm-m__inner > .hm-m__two,.hm-m__inner > .hm-m__ft,.hm-m__inner > .hm-m__project,.hm-m__h + .hm-m__lede,.hm-m__ripple-top > h2,.hm-m__ripple-top > .hm-ph,.hm-m__pillar,.hm-m__closing,.hm-m__closing-art,.hm-explore__heading,.hm-explore__heading + .hm-eyebrow,.hm-logos__title,.hm-wf__heading,.hm-wf__intro';
  var REVEAL='[data-hm-reveal],'+AUTO;
  var ANIM='.hm-m__map,.hm-ed__bg,.hm-wf__bg';
  var instant=!('IntersectionObserver' in window)||(window.Shopify&&window.Shopify.designMode);
  var ioR=null, ioA=null;
  function show(el,delay){
    if(delay) el.style.transitionDelay=delay+'ms';
    el.classList.add('is-in');
    if(delay) setTimeout(function(){el.style.transitionDelay='';},delay+900);
  }
  function onReveal(entries){
    var hits=[];
    entries.forEach(function(en){
      var el=en.target;
      if(en.isIntersecting){hits.push(el);}
      else if(en.boundingClientRect.bottom<0){ioR.unobserve(el);show(el,0);}
    });
    hits.sort(function(a,b){return a.compareDocumentPosition(b)&2?1:-1;});
    hits.forEach(function(el,k){ioR.unobserve(el);show(el,Math.min(k,MAXK)*STEP);});
  }
  function onAnim(entries){
    entries.forEach(function(en){
      if(en.isIntersecting||en.boundingClientRect.bottom<0){ioA.unobserve(en.target);en.target.classList.add('is-in');}
    });
  }
  function scan(root){
    root=root||document;
    var i,els=root.querySelectorAll(REVEAL);
    for(i=0;i<els.length;i++){
      if(els[i].classList.contains('is-in')||els[i].hasAttribute('data-hm-seen')) continue;
      els[i].setAttribute('data-hm-seen','');
      if(instant){els[i].classList.add('is-in');}
      else{if(!ioR) ioR=new IntersectionObserver(onReveal,{threshold:.15,rootMargin:'0px 0px -8% 0px'});ioR.observe(els[i]);}
    }
    var an=root.querySelectorAll(ANIM);
    for(i=0;i<an.length;i++){
      if(an[i].classList.contains('is-in')||an[i].hasAttribute('data-hm-seen-a')) continue;
      an[i].setAttribute('data-hm-seen-a','');
      if(instant){an[i].classList.add('is-in');}
      else{if(!ioA) ioA=new IntersectionObserver(onAnim,{threshold:.3});ioA.observe(an[i]);}
    }
  }
  window.__hmMotion={scan:scan};
  scan();
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
})();
